import styled from 'styled-components'
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const FooterWrapper = styled.footer`
  background: #1a1a1a;
  color: #fff;
  padding: 4rem 1rem 2rem;
`

const FooterContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    padding: 0;
  }
`

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 3rem;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 2rem;
  }
`

const FooterSection = styled.div`
  h3 {
    color: #fff;
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 1.25rem;
    
    @media (min-width: 768px) {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
  }

  p {
    color: #9ca3af;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
    line-height: 1.6;
    
    @media (min-width: 768px) {
      font-size: 0.95rem;
      margin-bottom: 1rem;
    }
  }
`

const CompanySection = styled(FooterSection)`
  .logo {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    color: #fff;
    
    @media (min-width: 768px) {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }
  }
  
  p {
    max-width: 400px;
  }
`

const LinkList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    margin-bottom: 0.75rem;
  }

  a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.3s ease;
    font-size: 0.9rem;
    display: inline-block;
    padding: 0.25rem 0;
    
    @media (min-width: 768px) {
      font-size: 1rem;
    }

    &:hover {
      color: #fff;
    }
  }
`

const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1.5rem;

  a {
    color: #9ca3af;
    font-size: 1.75rem;
    transition: color 0.3s ease;
    padding: 0.5rem;
    margin: -0.5rem;

    @media (min-width: 768px) {
      font-size: 1.5rem;
    }

    &:hover {
      color: #fff;
    }
  }
`

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #333;
  margin: 2rem 0;
`

const BottomBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.85rem;
  padding: 0 1rem;
  
  a {
    text-decoration: none;
    color: #fff;
    padding: 0.25rem 0;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.9rem;
  }
`

const BottomLinks = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  
  a {
    white-space: nowrap;
  }
`

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterContent>
          <CompanySection>
            <div className="logo">Morpheus Technology Pty Ltd</div>
            <p>
            Blue pill or red pill? Morpheus Technology Pty Ltd—your gateway to tech-driven success.            </p>
            <SocialLinks>
              {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a> */}
              <a href="https://x.com/cath_live_sol" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="https://www.linkedin.com/company/morpheus-tech-pty-ltd" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://github.com/morpheus-tech-io" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
            </SocialLinks>
          </CompanySection>

          <FooterSection>
            <h3>Services</h3>
            <LinkList>
              <li><Link to="/web2-services">Web2 Development</Link></li>
              <li><Link to="/web3-services">Web3 Solutions</Link></li>
              <li><Link to="/web2-services#enterprise-internal-systems-erp-solutions">Custom ERP</Link></li>
              <li><Link to="/web2-services#ai-automation-ai-agent-development">AI & Robotics Solutions</Link></li>
              <li><Link to="/web2-services#cloud-infrastructure-cloud-hosting-solutions">Cloud Services</Link></li>
              <li><Link to="/web2-services#digital-marketing-analytics-data-science-services">Data Services</Link></li>
        
            </LinkList>
          </FooterSection>

          <FooterSection>
            <h3>Company</h3>
            <LinkList>
              <li>
                <Link to="/about" onClick={() => {
                  window.scrollTo({
                    top: 0,
                    behavior: 'instant'
                  });
                }}>
                  About Us
                </Link>
              </li>
              <li><Link to="/#contact">Contact</Link></li>
              {/* <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/blog">Blog</Link></li> */}
            </LinkList>
          </FooterSection>

          <FooterSection>
            <h3>Contact Info</h3>
            <p>Level 4, 15 Moore St</p>
            <p>Acton, ACT 2601</p>
            <p>Phone: (61) 435868704</p>
            <p>Email: info@morpheus-tech.io</p>
          </FooterSection>
        </FooterContent>

        <Divider />

        <BottomBar>
          <div>
            © {new Date().getFullYear()} Company. All rights reserved.
          </div>
          <div>
            <Link to="/privacy">Privacy Policy</Link> • <Link to="/terms">Terms of Service</Link>
          </div>
        </BottomBar>
      </FooterContainer>
    </FooterWrapper>
  )
}

export default Footer